import {  all } from "redux-saga/effects";
import { authenticationWatcher } from "../authentication/saga";


export default function* watchSagas() {
    yield all([
      authenticationWatcher()
    ])
    // code after all-effect
  }